module.exports = __webpack_public_path__ + "static/media/TM.af13eb43.svg";